import Cookies from "js-cookie";

/**
 * @function getCookieValue
 * @description get cookie value
 */
export const getCookieValue = (name) => Cookies.get(name);

/**
 * @function setCookieValue
 * @description set cookie value
 */
export const setCookieValue = (name, value, ...rest) =>
  Cookies.set(name, value, { expires: 6, ...rest });

/**
 * @function removeCookieValue
 * @description remove cookie value
 */

export const removeCookieValue = (name) => Cookies.remove(name);

/**
 * @function setSessionStorage
 * @description set Session Storage value
 */
export const setSessionStorage = (name, value) =>
  sessionStorage.setItem(name, value);

/**
 * @function getSessionStorage
 * @description get Session Storage value
 */
export const getSessionStorage = (name, value) =>
  sessionStorage.getItem(name, value);

/**
 * @function removeSessionStorage
 * @description remove Session Storage value
 */
export const removeSessionStorage = (name, value) =>
  sessionStorage.removeItem(name, value);
